module.exports = __webpack_public_path__ + "static/media/EditGreen.036f17ee.svg";